import script from "./comp_cabecero_imagen_evento.vue?vue&type=script&setup=true&lang=js"
export * from "./comp_cabecero_imagen_evento.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__